export default "__VITE_ASSET__C3pvX6tA__"